export function getImageBackground({ customAttributes }) {
    const image = customAttributes?.backgroundImage;
    if (!image)
        return null;
    return image;
}
